module.exports = __webpack_public_path__ + "static/media/queen.f447b92a.PNG";